import { CloseCircleIcon } from '@mm/icons';
import classNames from 'classnames';
import React, { ReactNode } from 'react';
import './TagItem.scss';

type Props = {
  onDelete: () => void;
  text: string;
  preventDelete?: boolean;
  key?: string | number;
  icon?: 'trash' | 'cross';
  className?: string;
  customIcon?: ReactNode;
};

export const TagItem = ({
  onDelete,
  text,
  preventDelete = false,
  icon = 'trash',
  className = '',
  customIcon,
  ...props
}: Props) => {
  const iconName = icon === 'cross' ? 'fas fa-times' : 'far fa-trash-alt';
  const iconClassName = `tag-item__delete-icon ${iconName}`;

  const containerClassName = classNames('tag-item', className);

  return (
    <div {...props} className={containerClassName}>
      {text}
      {!preventDelete && !customIcon ? (
        <CloseCircleIcon
          onClick={onDelete}
          className={iconClassName}
          color="#009EFF"
        />
      ) : (
        customIcon
      )}
    </div>
  );
};
